import Tab from '@mui/material/Tab';
import { tabStyle } from 'common/components/AppLayout/AppLayout.styles';
import { usePreviousPath } from 'common/components/AppLayout/AppNavigation/usePreviousPath';
import { Link, useParams } from 'react-router';
import { Routes } from 'src/Routes.constants';

import { useTranslation } from 'react-i18next';
import { TabsContainer } from 'src/common/components/AppLayout/Components/TabsContainer';
import { a11yTabProps } from 'src/common/components/AppLayout/Components/utils';
import { useAuditTrailAvailable } from 'src/auditTrail/hooks/useAuditTrailAvailable';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

export const SimProductDetailsTabsLayout = ({
  children,
  additionalTopMargin = 0,
}: {
  children: React.ReactNode;
  firstTabHighlited?: boolean;
  additionalTopMargin?: number;
}) => {
  const { iccid } = useParams();
  const { t } = useTranslation();
  const previousPath = usePreviousPath();

  const locationEnabled = useHasFeatureFlag('Locations');

  const auditTrailEnabled = useAuditTrailAvailable();

  return (
    <TabsContainer content={children} additionalTopMargin={additionalTopMargin}>
      <Tab
        value={`${Routes.productsSim}/${iccid}`}
        label={t('products.tabs.general')}
        component={Link}
        to={`${Routes.productsSim}/${iccid}`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('products.tabs.general'))}
        replace
      />
      {locationEnabled ? (
        <Tab
          value={`${Routes.productsSim}/${iccid}/location`}
          label={t('products.tabs.location')}
          component={Link}
          to={`${Routes.productsSim}/${iccid}/location`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('products.tabs.location'))}
          replace
        />
      ) : null}
      <Tab
        value={`${Routes.productsSim}/${iccid}/history`}
        label={t('products.tabs.history')}
        component={Link}
        to={`${Routes.productsSim}/${iccid}/history`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('products.tabs.history'))}
        replace
      />
      <Tab
        value={`${Routes.productsSim}/${iccid}/history-analysis`}
        label={t('products.tabs.historyAnalysis')}
        component={Link}
        to={`${Routes.productsSim}/${iccid}/history-analysis`}
        state={{ previousPath }}
        sx={tabStyle}
        {...a11yTabProps(t('products.tabs.historyAnalysis'))}
        replace
      />
      {auditTrailEnabled ? (
        <Tab
          value={`${Routes.productsSim}/${iccid}/audit-trail`}
          label={t('products.tabs.auditTrail')}
          component={Link}
          to={`${Routes.productsSim}/${iccid}/audit-trail`}
          state={{ previousPath }}
          sx={tabStyle}
          {...a11yTabProps(t('products.tabs.auditTrail'))}
          replace
        />
      ) : null}
    </TabsContainer>
  );
};
